import React from 'react';

import { Link } from 'react-router-dom';

// Modal

// Icons
import { MdOutlineArrowRightAlt } from 'react-icons/md';

function WorkWithUs() {
  return (
    <section className="relative bg-center bg-no-repeat bg-cover bg-[url()]">
      <div class="absolute inset-0 bg-white md:bg-transparent md:bg-gradient-to-r sm:from-white sm:via-white/75 sm:to-transparent"></div>

      <div className="container relative max-w-screen-xl px-10 py-16 mx-auto md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-y-8 lg:gap-x-16 lg:items-start">
          <div className="block gap-4 mx-auto text-center lg:text-left lg:mx-0 md:flex md:items-center">
            <div className="basis-4/6">
              <h2 className="text-3xl font-bold sm:text-4xl">
                eDriveLab sta cercando te!
              </h2>

              <p className="mt-4 text-gray-600">
                Sei una persona pronta a mettersi in gioco? Questa è l'azienda
                che fa per te! Abbiamo aperto delle posizioni lavorative, fai
                click sulla mansione che fa per te e mandaci subito la tua
                candidatura.
              </p>
            </div>
            <div className="basis-2/6">
              <Link
                className="inline-flex items-center py-4 mt-8 text-white transition-all bg-blue-600 border border-blue-600 rounded px-9 hover:bg-transparent hover:text-blue-600 active:text-blue-500 focus:outline-none focus:ring"
                to="/carriera"
              >
                <span className="text-sm font-medium">
                  Scopri le posizioni aperte
                </span>
                <MdOutlineArrowRightAlt className="w-5 h-5 ml-3" />
              </Link>
            </div>
          </div>
          {/* <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {openPositions?.map((position, id) => (
              <Link
                key={id}
                to="/"
                className="block p-4 bg-white border border-gray-100 shadow-md rounded-xl focus:outline-none focus:ring hover:border-gray-200 hover:ring-1 hover:ring-gray-200"
              >
                <div className="flex items-center justify-start gap-4">
                  <span className="inline-block p-3 rounded-lg bg-gray-50">
                    {position.icon}
                  </span>
                  <h6 className="font-bold">{position.name}</h6>
                </div>
              </Link>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default WorkWithUs;
